"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRunningInJest = exports.isClientSide = exports.isServerSide = void 0;
const isServerSide = () => typeof window === 'undefined';
exports.isServerSide = isServerSide;
const isClientSide = () => typeof window !== 'undefined';
exports.isClientSide = isClientSide;
const isRunningInJest = () => process.env.JEST_WORKER_ID !== undefined;
exports.isRunningInJest = isRunningInJest;
